import { SET_ERROR } from '@actions/errorCodeActions'

const initialState = {
  showErrorModal: false,
  errorCode: '',
  HTTPcode: '',
  feedPageSlug: '',
  feedSubscriptionPlan: '',
  fetchAction: '',
  videoSlug: '',
  category: '',
  movieId: '',
  pathLocation: '',
}

interface ErrorCodeAction {
  type: string
  payload: {
    showErrorModal: boolean
    errorCode: string
    HTTPcode: string
    feedPageSlug: string
    feedSubscriptionPlan: string
    fetchAction: string
    videoSlug: string
    category: string
    movieId: string
    pathLocation: string
  }
}

export default function errorCodeReducer(state = initialState, action: ErrorCodeAction) {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}
